import { elakayAutoText } from '../pageInside/dataElakay';

// Display texts of the designs, translated (EN/FR/ES/HT/PT). Collection names
// are product names and stay as they are; the ORIGINAL gets a translated name.
export const designName = design =>
  design?.nameKey ? elakayAutoText(design.nameKey, design.name) : design?.name || '';

export const designDescription = design =>
  design?.descriptionKey ? elakayAutoText(design.descriptionKey, design.description) : design?.description || '';
